'use client';

import { GenericLoader } from '@eliadmin/core/src/components/ui/generic-loader';
import { Suspense } from 'react';

import { FleetImportContent } from '../../../components/profile/fleet-import-content';

export default function FleetImportPage() {
  return (
    <Suspense fallback={<GenericLoader />}>
      <FleetImportContent />
    </Suspense>
  );
}
